import React, { useState, useEffect } from "react";
import logo from '../logo.png';
import "../styles/ApplicationForm.css";
import { Formik, Form } from "formik"
import { useHistory } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
// import * as Yup from "yup"
import FormPage1 from "./FormPage1";

import FormPageStudent2 from "./FormPageStudent2";

import FormPage2 from "./FormPage2";
import FormPage1E from "./FormPage1E";
import FormPage2E from "./FormPage2E";
import FormPage3 from "./FormPage3";
import FormPage4 from "./FormPage4";
import { Button, Stepper, Step, StepLabel, Backdrop, CircularProgress } from '@material-ui/core'
import { FormValidation } from '../models/FormValidationModel';
import DateFnsUtils from '@date-io/date-fns';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import axios from 'axios';
import { ApiURL } from '../constants/ApiUrl'

const renderStep = (step, values, errors, touched, setFieldValue, type, id) => {
  // console.log(type,"ttttttttttttyyyyyyyyy")
  if (type === 'single') {
    switch (step) {
      case 0:
        return <FormPage1 errors={errors} touched={touched} values={values} setFieldValue={setFieldValue} appId={id} />;
      case 1:
        return <FormPage2 errors={errors} touched={touched} values={values} setFieldValue={setFieldValue} appId={id} />;
      case 2:
        return <FormPage3 errors={errors} touched={touched} values={values} setFieldValue={setFieldValue} appId={id} />;
      case 3:
        return <FormPage4 errors={errors} touched={touched} values={values} setFieldValue={setFieldValue} appId={id} />;
      default:
        return <FormPage1 errors={errors} touched={touched} values={values} setFieldValue={setFieldValue} appId={id} />;
    }

  }
  else if (type === 'student') {
    switch (step) {
      case 0:
        return <FormPage1 errors={errors} touched={touched} values={values} setFieldValue={setFieldValue} appId={id} />;
      case 1:
        return <FormPageStudent2 errors={errors} touched={touched} values={values} setFieldValue={setFieldValue} appId={id} />;
      case 2:
        return <FormPage3 errors={errors} touched={touched} values={values} setFieldValue={setFieldValue} appId={id} />;
      case 3:
        return <FormPage4 errors={errors} touched={touched} values={values} setFieldValue={setFieldValue} appId={id} />;
      default:
        return <FormPage1 errors={errors} touched={touched} values={values} setFieldValue={setFieldValue} appId={id} />;
    }

  }
  else {
    switch (step) {
      case 0:
        return <FormPage1 errors={errors} touched={touched} values={values} setFieldValue={setFieldValue} appId={id} />;
      case 1:
        return <FormPage2 errors={errors} touched={touched} values={values} setFieldValue={setFieldValue} appId={id} />;
      case 2:
        return <FormPage1E errors={errors} touched={touched} values={values} setFieldValue={setFieldValue} appId={id} />;
      case 3:
        return <FormPage2E errors={errors} touched={touched} values={values} setFieldValue={setFieldValue} appId={id} />;
      case 4:
        return <FormPage3 errors={errors} touched={touched} values={values} setFieldValue={setFieldValue} appId={id} />;
      case 5:
        return <FormPage4 errors={errors} touched={touched} values={values} setFieldValue={setFieldValue} appId={id} />;
      default:
        return <FormPage1 errors={errors} touched={touched} />;
    }
  }
};


const getSteps = (type) => {
  if (type === '')
    return [];
  if (type === 'single')
    return ["Doctor Details", "Educational Qualifications", "Correspondence Address", "Association with NMO"];
  else if (type === 'student')
    return ["Student Details", "Educational Qualifications", "Correspondence Address", "Association with NMO"];
  else
    return ["Doctor Details", " Your Educational Qualifications", "Spouse Details", "Spouse Educational Qualifications", "Correspondence Address", "Association with NMO"];
}

const saveData = (values, type, fee, id) => {
  // console.log(values,"image,,,,,,,,,,,,,,")
  var temp = {
    "appId": id,
    "appType": type,
    "appFee": fee,
    "applicants": [],
    "address": {
      "line1": values.line1,
      "line2": values.line2,
      "city": values.city,
      "state": values.state,
      "pincode": values.pincode
    },
    "nmo_state": values.nmo_state,
    "prant": values.prant,
    "nmo_unit": values.nmo_unit,
    "ref_person": values.ref_person,
    "ref_membership_no": values.ref_membership_no,
    "ref_person_phone": values.ref_person_phone,
    "state_sec_email": values.state_sec_email
  }
  var tempapplicant1 = {
    "name": values.name,
    "dob": values.dob,
    "gender": values.gender,
    "phone": values.phone,
    "email": values.email,
    "blood_group": values.blood_group,
    "degree": values.degree,
    "docstatus": values.docstatus,
    "qualifications": values.qualifications,
    "specialization": values.specialization,
    "college": values.college,
    "regno": values.regno,
    "profile_image": values.profile_image,
    "signature_image": values.signature_image,
    "cert_image": values.cert_image
  }
  temp.applicants.push(tempapplicant1);
  if (type === 'couple') {
    var tempapplicant2 = {
      "name": values.name1,
      "dob": values.dob1,
      "gender": values.gender1,
      "phone": values.phone1,
      "email": values.email1,
      "blood_group": values.blood_group1,
      "docstatus": values.docstatus1,
      "qualifications": values.qualifications1,
      "specialization": values.specialization1,
      "college": values.college1,
      "regno": values.regno1,
      "profile_image": values.profile_image1,
      "signature_image": values.signature_image1,
      "cert_image": values.cert_image1
    }
    temp.applicants.push(tempapplicant2);
  }
  console.log("SAVED", temp);
  return temp;
}

const inititalData = (type) => {
  if (type === "single") {
    return {
      name: '',
      dob: '',
      gender: '',
      profile_image: '',
      blood_group: '',
      phone: 0,
      email: '',
      signature_image: '',
      docstatus: '',
      qualifications: '',
      specialization: '',
      college: '',
      regno: '',
      cert_image: '',
      line1: '',
      line2: '',
      city: '',
      state: '',
      pincode: 0,
      nmo_unit: '',
      ref_person: '',
      ref_person_phone: 0,
      ref_membership_no: '',
      state_sec_email: ''
    }
  } else if (type === 'student') {
    return {
      name: '',
      dob: '',
      gender: '',
      profile_image: '',
      blood_group: '',
      phone: 0,
      email: '',
      signature_image: '',
      docstatus: '',
      qualifications: '',
      degree: '',
      // specialization: '',
      college: '',
      regno: '',
      cert_image: '',
      line1: '',
      line2: '',
      city: '',
      state: '',
      pincode: 0,
      nmo_unit: '',
      ref_person: '',
      ref_person_phone: 0,
      ref_membership_no: '',
      state_sec_email: ''
    }
  }
  else {
    return {
      name: '',
      dob: '',
      gender: '',
      profile_image: '',
      blood_group: '',
      phone: 0,
      email: '',
      signature_image: '',
      docstatus: '',
      qualifications: '',
      specialization: '',
      college: '',
      regno: '',
      cert_image: '',
      name1: '',
      dob1: '',
      gender1: '',
      profile_image1: '',
      blood_group1: '',
      phone1: 0,
      email1: '',
      signature_image1: '',
      docstatus1: '',
      qualifications1: '',
      specialization1: '',
      college1: '',
      regno1: '',
      cert_image1: '',
      line1: '',
      line2: '',
      city: '',
      state: '',
      pincode: 0,
      nmo_unit: '',
      ref_person: '',
      ref_person_phone: 0,
      ref_membership_no: '',
      state_sec_email: ''
    }
  }
}

// const valiDationData = (type) => {
//   if(type === 'single'){
//     return Yup.object({
//       name: Yup.string().min(3,'Must be atleast 3 characters').required('Required').matches(/^[aA-zZ.\s]+$/, "Only alphabets are allowed for this field "),
//       dob: Yup.date().required('Required'),
//       gender: Yup.string().required('Gender is required'),
//       profile_image: Yup.string().required('Profile image is required'),
//       blood_group: Yup.string().oneOf(['A+','A-','B+','B-','AB+','AB-','O+','O-']).required('Required'),
//       phone: Yup.number().positive().integer().moreThan(999999999,'Please enter valid mobile number').lessThan(10000000000,'Please enter valid mobile number').required('Mobile Number is required'),
//       email: Yup.string().email('Please enter valid Email').required('Required'),
//       signature_image: Yup.string().required('Signature Image is required'),
//       docstatus: Yup.string().required('Status is required'),
//       qualifications: Yup.string().required('Required'),
//       specialization: Yup.string(),
//       college: Yup.string().required('Required').matches(/^[aA-zZ.,\s]+$/, "Only alphabets are allowed for this field "),
//       regno: Yup.string().required('Required'),
//       cert_image: Yup.string().required('Document file is required'),
//       line1: Yup.string().required('Required'),//address seperate page
//       line2: Yup.string(),
//       city: Yup.string().required('Required'),
//       state: Yup.string().required('Required'),
//       pincode: Yup.number('Pin code should be a number').integer('Pin code should be a number').lessThan(1000000, "Enter valid pin code").moreThan(99999, "Enter valid pin code").required('Required'),
//       nmo_unit: Yup.string().required('Required'),//next page (Association with NMO)
//       ref_person: Yup.string().required('Required'),
//       ref_membership_no: Yup.string().required('Required'),
//       ref_person_phone: Yup.number().positive().integer().moreThan(999999999,'Please enter valid mobile number').lessThan(10000000000,'Please enter valid mobile number').required('Mobile Number is required'),
//       state_sec_email: Yup.string().email('Please enter valid Email').required('Required')

//     })
//   }
//   else{
//     return Yup.object({
//       name: Yup.string().min(3,'Must be atleast 3 characters').required('Required').matches(/^[aA-zZ.\s]+$/, "Only alphabets are allowed for this field "),
//       dob: Yup.date().required('Required'),
//       gender: Yup.string().required('Gender is required'),
//       profile_image: Yup.string().required('Profile image is required'),
//       blood_group: Yup.string().oneOf(['A+','A-','B+','B-','AB+','AB-','O+','O-']).required('Required'),
//       phone: Yup.number().positive().integer().moreThan(999999999,'Please enter valid mobile number').lessThan(10000000000,'Please enter valid mobile number').required('Mobile Number is required'),
//       email: Yup.string().email('Please enter valid Email').required('Required'),
//       signature_image: Yup.string().required('Signature Image is required'),
//       docstatus: Yup.string().required('Status is required'),
//       qualifications: Yup.string().required('Required'),
//       specialization: Yup.string(),
//       college: Yup.string().required('Required').matches(/^[aA-zZ.\s]+$/, "Only alphabets are allowed for this field "),
//       regno: Yup.string().required('Required'),
//       cert_image: Yup.string().required('Document file is required'),
//       name1: Yup.string().min(3,'Must be atleast 3 characters').required('Required').matches(/^[aA-zZ.\s]+$/, "Only alphabets are allowed for this field "),
//       dob1: Yup.date().required('Required'),
//       gender1: Yup.string().required('Gender is required'),
//       profile_image1: Yup.string().required('Profile image is required'),
//       blood_group1: Yup.string().oneOf(['A+','A-','B+','B-','AB+','AB-','O+','O-']).required('Required'),
//       phone1: Yup.number().positive().integer().moreThan(999999999,'Please enter valid mobile number').lessThan(10000000000,'Please enter valid mobile number').required('Mobile Number is required'),
//       email1: Yup.string().email('Please enter valid Email').required('Required'),
//       signature_image1: Yup.string().required('Signature Image is required'),
//       docstatus1: Yup.string().required('Status is required'),
//       qualifications1: Yup.string().required('Required'),
//       specialization1: Yup.string(),
//       college1: Yup.string().required('Required').matches(/^[aA-zZ.\s]+$/, "Only alphabets are allowed for this field "),
//       regno1: Yup.string().required('Required'),
//       cert_image1: Yup.string().required('Document file is required'),
//       line1: Yup.string().required('Required'),//address seperate page
//       line2: Yup.string(),
//       city: Yup.string().required('Required'),
//       state: Yup.string().required('Required'),
//       pincode: Yup.number('Pin code should be a number').integer('Pin code should be a number').lessThan(1000000, "Enter valid pin code").moreThan(99999, "Enter valid pin code").required('Required'),
//       nmo_unit: Yup.string().required('Required'),//next page (Association with NMO)
//       ref_person: Yup.string().required('Required'),
//       ref_membership_no: Yup.string().required('Required'),
//       ref_person_phone: Yup.number().positive().integer().moreThan(999999999,'Please enter valid mobile number').lessThan(10000000000,'Please enter valid mobile number').required('Mobile Number is required'),
//       state_sec_email: Yup.string().email('Please enter valid Email').required('Required')

//     })
//   }
// } 

function ApplicationForm() {
  const history = useHistory();
  const dispatch = useDispatch();
  const FormDataReducer = useSelector(state => state.FormDataReducer);
  const [activeStep, setActiveStep] = useState(0);
  const steps = getSteps(FormDataReducer.appType);
  const isLastStep = activeStep === steps.length - 1;
  const [Loader, setLoader] = useState(false)
  // const [Email, setEmail] = useState('')
  // const steps= ["Doctor Details", " Your Educational Qualifications", "Spouse Details", "Spouse Educational Qualifications",  "Correspondence Address", "Association with NMO"];
  // const pages = [<FormPage1/>, <FormPage2/>, <FormPage3/>]

  async function SetAllData() {
    dispatch({ type: "SET_FORM_ID" });
    const result = await axios.get(`${ApiURL}/constants/all`);
    const quali = result.data.qual.slice(0, 2)
    console.log(quali,"bbbbbbbbbb")
    dispatch({ type: "SET_STATES", payload: result.data.state });
    dispatch({ type: "SET_NMOSTATES", payload: result.data.nmostate });
  
    if (FormDataReducer.appType === 'student') {
      dispatch({ type: "SET_QUAL", payload: quali });
    

    } else {
      dispatch({ type: "SET_QUAL", payload: result.data.qual });

    }
  }
  useEffect(() => {

    if (FormDataReducer.appType === '' || FormDataReducer.appFee === 0) {
      history.push('/membership')
    }
    else {
      SetAllData();
    }
    // eslint-disable-next-line
  }, [])

  function loadScript(src) {
    return new Promise((resolve) => {
      const script = document.createElement("script");
      script.src = src;
      script.onload = () => {
        resolve(true);
      };
      script.onerror = () => {
        resolve(false);
      };
      document.body.appendChild(script);
    });
  }

  const handleSubmit = (values, actions) => {
    console.log(FormDataReducer, "number");
    // console.log('Run');
    if (isLastStep) {
      formSubmit(values, actions);
    }
    else {
      // console.log('Run');// setActiveStep(activeStep + 1);
      setActiveStep(activeStep + 1);
      actions.setTouched({});
      actions.setSubmitting(false);
    }
  }

  const handleBack = () => {
    setActiveStep(activeStep - 1);
  }

  const formSubmit = async (values, actions) => {

    // console.log(values);
    if (activeStep < steps.length - 1)
      return;
    var data = saveData(values, FormDataReducer.appType, FormDataReducer.appFee, FormDataReducer.appId);
    setLoader(true);
    const res = await loadScript("https://checkout.razorpay.com/v1/checkout.js");

    if (!res) {
      alert("Razorpay SDK failed to load. Are you online?");
      return;
    }

    const result = await axios.post(`${ApiURL}/payment/orders`, { "appId": FormDataReducer.appId, "amount": FormDataReducer.appFee });

    if (!result) {
      alert("Server error. Are you online?");
      return;
    }
    dispatch({ type: "SET_TRANSACTION", payload: result.data });
    const { amount, id: order_id, currency } = result.data;
    data = { ...data, "transactionId": order_id };
    dispatch({ type: "SET_FORM_DATA", payload: data });
    // setEmail(data.applicants[0].email)
    const appSaved = await axios.post(`${ApiURL}/api/submit_application`, data);
    const result2 = JSON.parse(localStorage.getItem("memno"))
    if (appSaved.data.status === 200) {
      const options = {
        key: process.env.REACT_APP_RZP_ID, // Enter the Key ID generated from the Dashboard
        amount: amount.toString(),
        currency: currency,
        name: "NMO Membership",
        description: "NMO Membership Payment",
        image: { logo },
        order_id: order_id,

        handler: async function (response) {
          const result3 = JSON.parse(localStorage.getItem("memno"))
          if (result3 !== null) {
            var data = {
              orderCreationId: order_id,
              razorpayPaymentId: response.razorpay_payment_id,
              razorpayOrderId: response.razorpay_order_id,
              razorpaySignature: response.razorpay_signature,
              "mem_no": result3

            };


          }
          else {
            var data = {
              orderCreationId: order_id,
              razorpayPaymentId: response.razorpay_payment_id,
              razorpayOrderId: response.razorpay_order_id,
              razorpaySignature: response.razorpay_signature,

            };
          }
          const result = await axios.post(`${ApiURL}/payment/success`, data,);
          console.log(result,"response")
          if (result.data.msg === "success") {
            localStorage.removeItem("memno")
            // setLoader(true)
            dispatch({ type: "FORM_SUCCESS" });
            history.replace('/membership/signup/success');

          } else {
            alert("Some error with payment. Please try again later.")
          }
        },
        prefill: {
          name: data.applicants[0].name,
          email: data.applicants[0].email,
          contact: data.applicants[0].phone,
        },
        theme: {
          color: "#e89b40",
        },
      };

      const paymentObject = new window.Razorpay(options);
      paymentObject.open();
      actions.setSubmitting(false);
      setLoader(false);
    }
    else {
      formSubmit(values, actions)
    }

  }


  var initialValue = inititalData(FormDataReducer.appType);
  // var validation = valiDationData(FormDataReducer.appType);
  return (
    <>

      <div className="appForm">
        <div className="deskStep">
          <Stepper alternativeLabel activeStep={activeStep}>
            {steps.map((item, index) => (
              <Step key={index}>
                <StepLabel>{item}</StepLabel>
              </Step>
            ))}
          </Stepper>
        </div>
        <div className="mobStep">
          <h4>{activeStep + 1} / {steps.length}</h4>
          <h3>{steps[activeStep]}</h3>
        </div>
        <MuiPickersUtilsProvider utils={DateFnsUtils}>
          {/* validationSchema={FormValidation(activeStep, FormDataReducer.appType)} */}
          <Formik initialValues={initialValue} validationSchema={FormValidation(activeStep, FormDataReducer.appType)} onSubmit={handleSubmit}>
            {(fprops) => {
              const { values, errors, touched, isSubmitting, setFieldValue } = fprops;
              // console.log(fprops);
              return (<Form>
                {renderStep(activeStep, values, errors, touched, setFieldValue, FormDataReducer.appType, FormDataReducer.appId)}

                <div style={{ textAlign: 'center', padding: '30px 0' }}>
                  {activeStep > 0 && <Button onClick={handleBack} variant="contained">Back</Button>}
                  {/* {activeStep < steps.length - 1 && <button onClick={() => setActiveStep(activeStep+1)} className="applyBtn" >Next</button>} */}
                  {/* {activeStep === steps.length - 1 && <button type="submit" disabled={isSubmitting} className="applyBtn">Proceed to Pay</button>} */}
                  <Button disabled={isSubmitting} type="submit" variant="contained" color="primary">{isLastStep ? "Proceed To Pay" : "Next"}</Button>
                </div>
              </Form>)
            }
            }
          </Formik>

        </MuiPickersUtilsProvider>
        {/* <div style={{textAlign: 'center', padding: '30px 0'}}>
              {activeStep > 0 && <button onClick={() => setActiveStep(activeStep-1)} className="applyBtn">Previous</button>}
              {activeStep < steps.length - 1 && <button onClick={() => setActiveStep(activeStep+1)} className="applyBtn" >Next</button>}
        </div> */}

      </div>
      <Backdrop className="backdrop" open={Loader}>
        <CircularProgress color="inherit" />
      </Backdrop>
    </>
  );
}

export default ApplicationForm;
